import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CurrentUser } from '../../lib/apiTypes';

interface AuthState {
  currentUser: CurrentUser | null;
  status: 'idle' | 'loading' | 'authenticated' | 'forbidden' | 'error';
  errorMessage: string | null;
}

const initialState: AuthState = {
  currentUser: null,
  status: 'idle',
  errorMessage: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authLoading(state) {
      state.status = 'loading';
      state.errorMessage = null;
    },
    authSuccess(state, action: PayloadAction<CurrentUser>) {
      state.currentUser = action.payload;
      state.status = 'authenticated';
      state.errorMessage = null;
    },
    authForbidden(state, action: PayloadAction<string>) {
      state.currentUser = null;
      state.status = 'forbidden';
      state.errorMessage = action.payload;
    },
    authError(state, action: PayloadAction<string>) {
      state.currentUser = null;
      state.status = 'error';
      state.errorMessage = action.payload;
    },
    signOut(state) {
      state.currentUser = null;
      state.status = 'idle';
      state.errorMessage = null;
    },
  },
});

export const { authLoading, authSuccess, authForbidden, authError, signOut } =
  authSlice.actions;
export default authSlice.reducer;
